import { message } from 'antd'

import {
    useUpdateJobPauseExceptionMutation,
    JobDetailsDocument,
} from '~/gql/graphql'
import logger from '~/lib/logger'
export function MutationOperation() {
    const [updateJobException] = useUpdateJobPauseExceptionMutation()

    return {
        updateJobException: async (variables: {
            jobId: number
            pauseException: boolean
        }) => {
            try {
                const response = await updateJobException({
                    variables: { ...variables },
                    refetchQueries: [
                        {
                            query: JobDetailsDocument,
                            variables: { id: variables.jobId },
                        },
                    ],
                })

                const action = variables.pauseException ? 'paused' : 'resumed'

                message.success(
                    `Successfully ${action} auto exceptions creation`,
                )
                return response
            } catch (err) {
                logger.exception(err, {
                    extra: {
                        info: 'Failed to update job exception status',
                    },
                })
                message.error('Failed to update status')
            }
        },
    }
}
